/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import { isNone } from '@ember/utils';
import { LogTypeNames } from 'cio/utils/activity-log-types';
import LogModel from 'cio/models/log';

interface ActivityLogRowTypeArgs {
  log: LogModel;
}

export default class ActivityLogRowType extends Component<ActivityLogRowTypeArgs> {
  @computed('args.log.{parsedType,deliveryTypeName}')
  get typeName() {
    let { parsedType } = this.args.log;
    let name = LogTypeNames[parsedType];

    if (isNone(name)) {
      return parsedType;
    }

    return name.replace(/\bAction\b/, this.args.log.deliveryTypeName);
  }
}
